import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUpdateProfile } from '../../api/queries'
import { ErrorNotice } from '../../components/ErrorNotice'
import { Button, Field, Input } from '../../components/ui'
import { useSession } from '../../session'
import { AuthShell } from './AuthShell'

/**
 * Экран 1.3 «Знакомство». Один экран, один раз, при первом входе.
 *
 * Причина, по которой это не отложено в необязательный профиль: без имени человека
 * не найти в списке участников, то есть его нельзя позвать на встречу.
 */
export function WelcomePage() {
  const { user } = useSession()
  const navigate = useNavigate()
  const save = useUpdateProfile()

  const [firstName, setFirstName] = useState(user.first_name)
  const [lastName, setLastName] = useState(user.last_name)
  const [position, setPosition] = useState(user.position)

  const ready = firstName.trim().length > 0 && lastName.trim().length > 0

  return (
    <AuthShell
      title="Давайте знакомиться"
      subtitle="Имя и фамилия нужны, чтобы коллеги нашли вас в списке участников. Заполняется один раз."
    >
      <form
        className="flex flex-col gap-4"
        onSubmit={(event) => {
          event.preventDefault()
          if (!ready) return
          save.mutate(
            {
              first_name: firstName.trim(),
              last_name: lastName.trim(),
              position: position.trim(),
            },
            { onSuccess: () => navigate('/', { replace: true }) },
          )
        }}
      >
        <Field label="Имя">
          <Input autoFocus value={firstName} onChange={(event) => setFirstName(event.target.value)} />
        </Field>
        <Field label="Фамилия">
          <Input value={lastName} onChange={(event) => setLastName(event.target.value)} />
        </Field>
        <Field
          label="Должность"
          hint="Не обязательно, но помогает различить однофамильцев при приглашении."
        >
          <Input
            value={position}
            placeholder="Например, руководитель отдела продаж"
            onChange={(event) => setPosition(event.target.value)}
          />
        </Field>

        {save.error && <ErrorNotice error={save.error} />}

        <Button type="submit" variant="primary" size="lg" disabled={!ready} loading={save.isPending}>
          Готово
        </Button>
      </form>
    </AuthShell>
  )
}
